import { IReasonProps } from '../types';
import { Text, TextSize } from '@components/Text';
import { useTranslation } from 'react-i18next';

const Reason = (props: IReasonProps) => {
  const { value } = props;

  const { t } = useTranslation();

  return (
      <Text size={TextSize.S}>
        {t(
            `problematicParcelsPage.reasons.${value}`,
            { defaultValue: value }
        )}
      </Text>
  );
};

export default Reason;